/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Buy_Messages_Modal_TitleInputs */

const es_components_buy_messages_modal_title = /** @type {(inputs: Components_Buy_Messages_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprar mensajes adicionales`)
};

const en_components_buy_messages_modal_title = /** @type {(inputs: Components_Buy_Messages_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buy additional messages`)
};

/**
* | output |
* | --- |
* | "Buy additional messages" |
*
* @param {Components_Buy_Messages_Modal_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_buy_messages_modal_title = /** @type {((inputs?: Components_Buy_Messages_Modal_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Buy_Messages_Modal_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_buy_messages_modal_title(inputs)
	return en_components_buy_messages_modal_title(inputs)
});
export { components_buy_messages_modal_title as "components.buy_messages_modal.title" }